import React, { useMemo, useRef, useState } from "react";
import { secondsToHHMM, timeToSeconds } from "../../../../Utilitie";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import DynamicTable from "../../../../Extra/DynamicTable";
import MachineEngMonthWiseGraph from "./MachineEngMonthWiseGraph";
import MachineEngSecWiseGraph from "./MachineEngSecWiseGraph";

const MachineEngMonthWise = ({ data }) => {
  const table = useRef();
  const [selectedMonth, setSelectedMonth] = useState("");
  const [active, setActive] = useState("Demand");

  const Header = {
    reportDate: "reportDate",
    section: "section",
    From_Station: "From_Station",
    To_Station: "To_Station",
    No_Of_Demand_By_Engg: "No_Of_Demand_By_Engg",
    Engg_Demand: "Engg_Demand",
    No_Of_Demand_Agreed_GIVEN: "No_Of_Demand_Agreed_GIVEN",
    Agreed_Demand: "Agreed_Demand",
    availed_No: "availed_No",
    Availed: "Availed",
    Actual_Output_in_Meter: "Actual_Output_in_Meter",
  };

  const keys = [
    "MONTH",
    "DEMAND",
    "DEMAND HRS",
    "AGREED",
    "AGREED HRS",
    "AVAILED",
    "AVAILED HRS",
    "OUTPUT",
  ];

  const monthWiseTableData = useMemo(() => {
    if (!data?.length) return [];

    const grouped = {};

    data.forEach((item) => {
      const d = new Date(item.reportDate);

      const month =
        [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ][d.getMonth()] +
        "-" +
        d.getFullYear();

      if (!grouped[month]) {
        grouped[month] = {
          Month: month,
          No_Of_Demand_By_Engg: 0,
          Engg_Demand: 0,
          No_Of_Demand_Agreed_GIVEN: 0,
          Agreed_Demand: 0,
          Availed: 0,
          Availed_No: 0,
          Actual_Output_in_Meter: 0,
        };
      }

      grouped[month].No_Of_Demand_By_Engg += +item.No_Of_Demand_By_Engg || 0;
      grouped[month].Engg_Demand += timeToSeconds(
        item.Engg_Demand || "00:00:00",
      );
      grouped[month].No_Of_Demand_Agreed_GIVEN +=
        +item.No_Of_Demand_Agreed_GIVEN || 0;
      grouped[month].Agreed_Demand += timeToSeconds(
        item.Agreed_Demand || "00:00:00",
      );

      const availed = timeToSeconds(item.Availed || "00:00:00");
      grouped[month].Availed += availed;
      if (item.Availed !== "00:00:00") grouped[month].Availed_No += 1;

      grouped[month].Actual_Output_in_Meter +=
        +item.Actual_Output_in_Meter || 0;
    });

    return Object.values(grouped).map((item) => ({
      ...item,
      Engg_Demand: secondsToHHMM(item.Engg_Demand),
      Agreed_Demand: secondsToHHMM(item.Agreed_Demand),
      Availed: secondsToHHMM(item.Availed),
    }));
  }, [data]);

  const sectionYearData = useMemo(() => {
    if (!data?.length) return [];

    const months = [
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
      "JAN",
      "FEB",
      "MAR",
    ];

    const grouped = {};

    data.forEach((item) => {
      const d = new Date(item.reportDate);
      const monthIndex = d.getMonth();
      const monthName = months[(monthIndex + 9) % 12];

      let startYear = d.getFullYear();
      let endYear = d.getFullYear();

      // Financial Year Logic
      if (monthIndex >= 3) {
        endYear = startYear + 1;
      } else {
        startYear = startYear - 1;
      }

      const financialYear = `${startYear}-${endYear}`;
      const section = item.section || "UNKNOWN";
      const key = `${section}-${financialYear}`;

      if (!grouped[key]) {
        grouped[key] = {
          ID: Object.keys(grouped).length + 1,
          year: financialYear,
          section,
        };

        months.forEach((m) => {
          grouped[key][m] = 0;
        });
      }

      const value =
        active === "Agreed"
          ? +item.No_Of_Demand_Agreed_GIVEN || 0
          : active === "Demand"
            ? +item.No_Of_Demand_By_Engg || 0
            : 0;

      grouped[key][monthName] += value;
    });

    return Object.values(grouped);
  }, [data, active]);

  const mdata = useMemo(() => {
    if (!selectedMonth) return setSelectedMonth(monthWiseTableData?.[0]?.Month);

    return data.filter((item) => {
      const d = new Date(item.reportDate);
      const month =
        [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ][d.getMonth()] +
        "-" +
        d.getFullYear();

      return month === selectedMonth;
    });
  }, [selectedMonth, data]);

  return (
    <div className="papaDiv">
      <div className="row">
        <div className="table-responsive col-md-5">
          <h5 className="text-center bg-dark text-white p-2">
            Month Wise Data
          </h5>

          <table
            ref={table}
            className="table table-bordered table-striped text-center"
            style={{ fontSize: "13px", height: "450px" }}
          >
            <thead>
              <tr className="table-dark">
                <th>Sr No.</th>
                {keys.map((head, i) => (
                  <th key={i}>{head}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {monthWiseTableData.map((o, i) => (
                <tr
                  key={i}
                  style={{ cursor: "pointer" }}
                  className={selectedMonth === o.Month ? "table-dark" : ""}
                  onClick={() => setSelectedMonth(o.Month)}
                >
                  <td>{i + 1}</td>
                  <td>{o.Month}</td>
                  <td>{o.No_Of_Demand_By_Engg}</td>
                  <td>{o.Engg_Demand}</td>
                  <td>{o.No_Of_Demand_Agreed_GIVEN}</td>
                  <td>{o.Agreed_Demand}</td>
                  <td>{o.Availed_No}</td>
                  <td>{o.Availed}</td>
                  <td>{o.Actual_Output_in_Meter}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="mb-3">
            <DownloadExcel
              tableRef={table}
              fileName="MONTH WISE ENG BLOCK DATA"
            />
          </div>
        </div>

        <div className="col-md-7">
          <div className="text-center bg-dark p-2 text-white ">
            <h5>Month Wise Data ({selectedMonth})</h5>
          </div>
          {selectedMonth ? (
            <DynamicTable
              data={mdata.map((item) => ({
                ...item,
                availed_No: item.Availed === "00:00:00" ? "0" : 1,
              }))}
              headers={Header}
              rowsPerPage={10}
              fontSize="12px"
            />
          ) : (
            <div className="alert alert-danger text-center" role="alert">
              {" "}
              Select Row For Month Wise Data
            </div>
          )}
        </div>
      </div>
      <div className="row">
        {monthWiseTableData && (
          <div className="col-md-6 border">
            <MachineEngMonthWiseGraph data={monthWiseTableData} />
          </div>
        )}
        {sectionYearData && (
          <div className="col-md-6">
            <MachineEngSecWiseGraph
              data={sectionYearData}
              setActive={setActive}
              active={active}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MachineEngMonthWise;
